import { PRODUCT_CATEGORIES_OPTIONS } from '../../features/admin/product/constants/product.constant';

export const PRODUCT_CATEGORIES = Array.from(PRODUCT_CATEGORIES_OPTIONS.entries())
    .sort(([, a], [, b]) => a.order! - b.order!)
    .map(([filter, option]) => ({
        label: option.label,
        filter,
        image: option.image!,
    }));

export const NAV_ITEMS = [
    {
        label: 'Products',
        route: '/products',
        children: PRODUCT_CATEGORIES,
    },
    { label: 'About Us', route: '/about-us' },
    { label: 'Blogs', route: '/blogs' },
    { label: 'Contact Us', route: '/contact-us' },
];
